import { Inject, Injectable, Optional } from '@angular/core';
import { DashboardCardService, DashboardCard, LastVsThisMonthSalesAmountSummaryCardComponent, LastVsThisWeekSalesAmountSummaryCardComponent, LastVsThisYearSalesAmountSummaryCardComponent, InvoiceStatisticsChartCardComponent, SalesSummaryCardComponent } from 'gung-dashboard';
import { AuthService, NavigationConfig, ProductService } from 'gung-standard';
import { CultLastVsThisMonthMeetingsAmountSummaryCardComponent } from '../components/cult-last-vs-this-month-meetings-amount-summary-card/cult-last-vs-this-month-meetings-amount-summary-card.component';
import { CultMeetingsConvertedIntoSalesSummaryCardComponent } from '../components/cult-meetings-converted-into-sales-summary-card/cult-meetings-converted-into-sales-summary-card.component';
import { CultSalesSummaryCardComponent } from '../components/cult-sales-summary-card/cult-sales-summary-card.component';
import { map } from 'rxjs';
import { CultSalespersonSelectComponent } from '../components/cult-salesperson-select/cult-salesperson-select.component';
import { CultDashboardDataService } from './cult-dashboard-data.service';
import { CultInvoiceStatisticsChartCardComponent } from '../components/cult-invoice-statistics-chart-card/cult-invoice-statistics-chart-card.component';
import { CultLastVsThisYearSalesCardComponent } from '../components/cards/cult-last-vs-this-year-sales-card/cult-last-vs-this-year-sales-card.component';
@Injectable({
  providedIn: 'root'
})
export class CultDashboardCardService extends DashboardCardService {
  constructor(
    protected authService: AuthService, 
    protected dashboardDataService: CultDashboardDataService, 
    @Optional() @Inject('environment') protected environment: NavigationConfig
    ) {
    super(authService, environment);
    
    
    authService
      .getHasRoles('SALES')
      .pipe(
        map(isAdmin => {
          dashboardDataService.currentMessage.subscribe(preCondition => {
            console.log('CultDashboardCardService [preCondition]', preCondition);
            this.clearCards();
            if (isAdmin) {
              this.addCard(
                new DashboardCard(CultSalespersonSelectComponent, 'col-xs-12 col-md-12 col-xl-12', preCondition)
              );
            }
            
            this.addCard(new DashboardCard(CultLastVsThisMonthMeetingsAmountSummaryCardComponent, 'col-xs-12 col-md-6', preCondition));
            this.addCard(new DashboardCard(CultMeetingsConvertedIntoSalesSummaryCardComponent, 'col-xs-12 col-md-6', preCondition));
            this.addCard(new DashboardCard(CultLastVsThisYearSalesCardComponent, 'col-xs-12 col-md-6 col-xl-4', preCondition));
            this.addCard(new DashboardCard(LastVsThisMonthSalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-4', preCondition));
            this.addCard(new DashboardCard(LastVsThisWeekSalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-4', preCondition));


            this.addCard(new DashboardCard(CultInvoiceStatisticsChartCardComponent, 'col-12', preCondition));
            this.addCard(new DashboardCard(CultSalesSummaryCardComponent, 'col-12', preCondition));
          });
        })
      ).subscribe();
  }
}
